import { makeAutoObservable } from "mobx"

export default class UserStore {
    constructor() {
        this._isAuth = JSON.parse(window.localStorage.getItem('isAuth')) || false
        this._user = JSON.parse(window.localStorage.getItem('user')) || {}
        this._token = JSON.parse(window.localStorage.getItem('token')) || null
        this._hasRoleUserForSite = false
        this._hasRoleShop = false
        this._hasRoleOpt = false
    //    this._viewAsManager = false; // ✅ новое свойство
        this._viewAsManager = JSON.parse(window.localStorage.getItem('viewAsManager')) || false; // <-- читаем
        makeAutoObservable(this)
    }

    setIsAuth(bool) {
        this._isAuth = bool
        window.localStorage.setItem('isAuth', JSON.stringify(bool));
    }
    setUser(user) {
        this._user = user
        window.localStorage.setItem('user', JSON.stringify(user));
    }
    setToken(token) {
        this._token = token
        window.localStorage.setItem('token', JSON.stringify(token));
    }

    setHasRoleShop(value) {
        this._hasRoleShop = value
    }

    setHasRoleOpt(value) {
        this._hasRoleOpt = value
    }

    setHasRoleUserForSite(value) {
        this._hasRoleUserForSite = value
    }
    setviewAsManager(bool) {
      this._viewAsManager = bool;
      window.localStorage.setItem('viewAsManager', JSON.stringify(bool)); // <-- сохраняем
    }
    
    // Можно сделать computed свойство:
    get effectiveRole() {
      if (this._hasRoleShop === true && this.viewAsManager) {
        return 'user'; // когда включен режим клиента
      }
      return this.user.role;
    }
    get viewAsManager() {
      return this._viewAsManager;
    }

    get isAuth() {
        return this._isAuth
    }
    get user() {
        return this._user
    }
    get token() {
        return this._token
    }
    get hasRoleShop() {
        return this._hasRoleShop
    }

    get hasRoleOpt() {
        return this._hasRoleOpt
    }

    get hasRoleUserForSite() {
        return this._hasRoleUserForSite
    }
    
}